<template>
    <div v-if="examination">
        <a class="return-link" @click="goToExaminationsList">
            <img class="arrow-img reverse" src="../../../assets/images/arrow-red.png" />
            {{ $t('GO_BACK_TO_EXAMINATIONS') }}
        </a>
        <div v-if="examination.publishedResultDescription" class="row mb-3">
            <div class="examination__description col-xs-12">
                <h3 class="title-content">
                    {{ $t('EXAMINATION_SUMMARY_FROM', { date: dateFormat($moment(examination.isoDate)) }) }}
                </h3>
                <h3 v-if="examination.additionalData">
                    {{ $t('EXAMINATION_ID', { id: examination.additionalData }) }}
                </h3>
                <div v-html="examination.publishedResultDescription"></div>
            </div>
        </div>
        <div v-else>
            <div class="row examination__description col-xs-12">
                <h3 class="title-content">
                    {{ `${$t('EXAMINATION_RESULT_FROM')} ${dateFormat($moment(examination.isoDate))}` }}
                </h3>
            </div>
            <h3 class="mt-2 mb-4">{{ $t('RESULT_AVAILABLE_AS_FILE') }}</h3>
        </div>
        <div v-if="showThermogramAndExportSection" class="row my-3">
            <div class="pull-right mr-3 my-1">
                <button class="app-btn app-btn--big app-btn-primary" @click="seeTermogram(examinationId)">
                    {{ $t('SEE_TERMOGRAM') }}
                </button>
            </div>
            <div class="pull-right mr-3 my-1">
                <button class="app-btn app-btn--big app-btn-primary" @click="fileExport('pdf')">
                    {{ $t('PDF_EXPORT') }}
                </button>
            </div>
            <div class="pull-right mr-3 my-1">
                <button class="app-btn app-btn--big app-btn-primary" @click="fileExport('zip')">
                    {{ $t('DICOM_EXPORT') }}
                </button>
            </div>
        </div>
        <div v-if="examination.documentPreviews.length > 0">
            <h3 class="title-content">
                {{ $t('FILES') }}
            </h3>
            <div class="col-xs-12 px-0 file" v-for="document in examination.documentPreviews">
                <div class="content">
                    <span v-text="getDocumentTitle(document)"></span>
                    <a class="pull-right" @click="saveDocument(document)">
                        {{ $t('DOWNLOAD_PDF') }}<img class="arrow-img" src="../../../assets/images/arrow-red.png" />
                    </a>
                </div>
                <div class="icon" @click="saveDocument(document)">
                    <img src="../../../assets/images/pdf-icon.png" />
                </div>
            </div>
        </div>
        <div class="col-xs-12" v-else>
            {{ $t('NO_DOCUMENTS_TO_DOWNLOAD') }}
        </div>
    </div>
</template>

<script>
import b64toBlob from 'b64-to-blob';
import { mapGetters } from 'vuex';
import { extendExaminationIsoDateInformation, logoutUser, seeTermogram } from './../../../main';
import {
    BASIC_AUTOMATIC_ANALYSIS,
    BRASTER_INFORMATION, DEEPPROCESSING,
    MANUAL_EVALUATION,
    REJECTED,
    REJECTED_WITH_ERROR,
} from '../../../assets/js/examinationUtils';

const downloadFile = (content, fileName) => {
    const blob = b64toBlob(content, 'application/octet-stream');
    const link = document.createElement('a');
    link.download = fileName;
    link.href = URL.createObjectURL(blob);
    link.dispatchEvent(new MouseEvent(`click`, { bubbles: true, cancelable: true, view: window }));
};

export default {
    data() {
        return {
            examinationId: this.$route.params.id,
        };
    },
    computed: {
        ...mapGetters(['accountTypeIsPro']),
        showThermogramAndExportSection() {
            return (
                this.accountTypeIsPro &&
                this.examination.status &&
                ![REJECTED, REJECTED_WITH_ERROR].includes(this.examination.status.name)
            );
        },
    },
    methods: {
        goToExaminationsList() {
            this.$router.push({ name: 'lista-wynikow' });
        },
        getDocumentTitle(document) {
            return this.$t('PDF_DESCRIPTION', {
                examinationTitle: this.getTranslatedDocumentName(document),
                examinationDate: this.dateFormat(this.$moment(this.examination.isoDate)),
            });
        },
        getTranslatedDocumentName({ serviceName }) {
            if (serviceName === BASIC_AUTOMATIC_ANALYSIS) {
                return this.$t('SAI_INTERPRETATION');
            } else if (serviceName === DEEPPROCESSING) {
                return this.$t('SAI_INTERPRETATION');
            } else if (serviceName === MANUAL_EVALUATION) {
                return this.$t('MANUAL_INTEPRETATION');
            } else {
                return this.$t('BRASTER_TEAM_INFORMATION');
            }
        },
        saveDocument(doc) {
            const dateInfo = this.$moment(doc.documentGenerationDate).format('YYYY-MM-DD_HHmmss');
            const fileName = `${this.getTranslatedDocumentName(doc).replace(/ /g, '_')}_${dateInfo}.pdf`;
            const returnTranslation = doc.translationCountryCode !== 'PL';
            this.$http
                .post(`/examination/api/result/getFullDocument`, { ...doc, returnTranslation })
                .then(r => downloadFile(r.data.documentBody, fileName));
        },
        fileExport(type) {
            const endpoint = type === 'pdf' ? 'downloadFullPdf/' : 'downloadDicom/';
            const dateInfo = this.$moment(this.examination.isoDate).format('YYYY-MM-DD_HHmmss');
            const fileName = `${this.$t('THERMOGRAPHIC_IMAGES').replace(/ /g, '_')}_${dateInfo}.${type}`;
            this.$http
                .get(`/examination/api/result/${this.examinationId}/${endpoint}`)
                .then(r => downloadFile(r.data.content, fileName));
        },
        seeTermogram,
    },
    asyncComputed: {
        examination() {
            return this.$http.get(`/examination/api/result/${this.examinationId}/getExaminationData`).then(
                ({ data }) => {
                    this.$cookie.delete('redirectUrlAfterLogin');
                    return extendExaminationIsoDateInformation(data);
                },
                ({ status }) => {
                    if (status === 403) {
                        const redirectUrlAfterLogin = this.$cookie.get('redirectUrlAfterLogin');
                        if (redirectUrlAfterLogin == null || !redirectUrlAfterLogin.includes('/wyniki-badan/')) {
                            this.$cookie.set('redirectUrlAfterLogin', this.$route.fullPath);
                            logoutUser();
                        } else {
                            this.$cookie.delete('redirectUrlAfterLogin');
                            this.$router.push({ name: 'moje-konto' });
                        }
                    }
                },
            );
        },
    },
};
</script>

<style scoped>
.return-link {
    display: block;
    font-size: 14px;
    font-weight: 700;
    margin-bottom: 30px;
}

.arrow-img {
    height: 7px;
    width: auto;
    margin-bottom: 2px;
}

.arrow-img.reverse {
    transform: rotate(180deg);
}

.date-wrapper {
    border: 1px solid #ede8e4;
    color: #54504c;
    display: flex;
    padding: 0;
    float: left;
    width: 116px;
    margin: 10px 0 20px;
}

.date-wrapper .left,
.date-wrapper .right {
    padding: 5px;
    display: flex;
    flex-direction: column;
    width: 60px;
    height: 60px;
    text-align: center;
}

.date-wrapper .left {
    background-color: #ede8e4;
    border-right: 2px solid #ede8e4;
    float: left;
}

.date-wrapper .right {
    float: right;
    justify-content: center;
}

.date-day {
    display: block;
    font-size: 32px;
    font-weight: 700;
    line-height: 24px;
}

.examination__description {
    font-size: 18px;
}

.examination__description__result {
    color: #77c072;
    margin: 20px 0;
}

.file {
    background-color: #fff;
    border: 1px solid #cf004a;
    display: flex;
    float: left;
    margin-top: 20px;
    width: 100%;
}

.content {
    float: left;
    font-weight: 700;
    padding: 20px;
    width: calc(100% - 70px);
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
}

.icon {
    background-color: #fcfbfa;
    border-left: 1px solid #fcfbfa;
    padding: 15px;
    text-align: center;
    float: left;
    width: 70px;
    cursor: pointer;
}

.icon img {
    width: 22px;
    height: auto;
}

a {
    cursor: pointer;
}

.info {
    color: #000000;
    display: flex;
    padding: 0;
    float: left;
    width: 116px;
    margin: 10px 0 20px;
}

.info-left {
    background-color: #ede8e4;
    border-right: 2px solid #ede8e4;
    float: left;
    padding: 5px;
    display: flex;
    flex-direction: column;
    width: 60px;
    height: 60px;
    text-align: center;
}

.info-right {
    padding: 5px -3px 5px 3px;
    display: flex;
    flex-direction: column;
    width: 130px;
    height: 60px;
    text-align: left;
}

.info-right-label {
    width: 120px;
    height: 15px;
    padding: 0;
}

.info-number {
    font-size: 30px;
}
</style>



// WEBPACK FOOTER //
// result-detailed.vue?15b949c3